module.exports = __webpack_public_path__ + "media/images/red_flag2-c4a407b07ef11a2f3f33b172498ea853.png";